import { createReducer, on } from '@ngrx/store';
import { setChartData } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/chart-data/chart-data.actions';
import { addFundChartCalc, addFundChartCalcs, removeFundChartCalc, setFundChartCalcs, toggleFundChartCalc, } from './calcs.actions';
export const calcs = createReducer([], on(setChartData, (state, { chartData }) => chartData.params.calcs), on(addFundChartCalc, (state, { metric }) => {
    const _calcs = state.filter((c) => c.id !== metric.id);
    return [..._calcs, metric];
}), on(addFundChartCalcs, (state, { metrics }) => {
    const newCalcs = metrics.filter((c) => {
        return !state.find((_) => _.id === c.id);
    });
    return [...state, ...newCalcs];
}), on(toggleFundChartCalc, (state, { metric }) => {
    return state.map((calc) => {
        if (calc.id === metric.id) {
            const include = !calc.include;
            return { ...calc, include };
        }
        return calc;
    });
}), on(removeFundChartCalc, (state, { metric }) => state.filter((calc) => calc.id !== metric.id)), on(setFundChartCalcs, (state, { metrics }) => metrics));
